import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class UnitMatchingService extends BaseService {

	constructor() {	
		super();
	}
	
	async getUnitMatchingSets() {
		var data = await this.makeGETRequest('/api/resource/unit-matching');		
		return data;		
	}
	
	async getUnitMatchingSet(id) {
		var data = await this.makeGETRequest('/api/resource/unit-matching/' + id);		
		return data;		
	}
	
	async saveUnitMatchingSet(unitMatchSet, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/unit-matching/' + unitMatchSet.unitMatchId, unitMatchSet);
		} else {
			saved = await this.makePOSTRequest('/api/resource/unit-matching', unitMatchSet);
		}
		return saved;		
	}	
	
	async deleteUnitMatchingSet(unitMatchId) {
		var data = await this.makeDELETERequest('/api/resource/unit-matching/' + unitMatchId);		
		return data;		
	}
	
	exportUnitMatchingSet(unitMatchId) {	
		this.downloadFile('/api/resource/unit-matching/' + unitMatchId + '/export');		
	};	
	
	async checkMatchSet(unitMatchId, checkModel) {
		var results = await this.makePOSTRequest('/api/resource/unit-matching/' + unitMatchId + '/check', checkModel);
		return results;		
	}	
	
}